import * as actionTypes from "../actionTypes.js";

// authStatus tri-state — needed because the access token is now an HttpOnly
// cookie that JS cannot see. On first paint we don't know if the user is
// signed in until ProtectedRoutes calls /me on the server.
//   "unknown"        -> haven't checked yet (initial / on hard reload)
//   "authenticated"  -> /me succeeded OR a fresh login just succeeded
//   "unauthenticated"-> /me returned 401 OR the user logged out
const initialState = {
  authStatus: "unknown",
  isAuthenticated: false,
  user: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOG_IN:
      // No token is persisted on the frontend — the cookie handles it.
      return {
        ...state,
        authStatus: "authenticated",
        isAuthenticated: true,
        user: action.payload,
      };

    case actionTypes.BOOTSTRAP_AUTH_OK:
      return {
        ...state,
        authStatus: "authenticated",
        isAuthenticated: true,
        user: action.payload,
      };

    case actionTypes.BOOTSTRAP_AUTH_FAIL:
      return {
        ...state,
        authStatus: "unauthenticated",
        isAuthenticated: false,
        user: null,
      };

    case actionTypes.LOG_OUT:
      sessionStorage.clear();
      localStorage.clear();
      return {
        ...initialState,
        authStatus: "unauthenticated",
      };

    default:
      return state;
  }
};

export default authReducer;
